import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    placeholder: String,
    empty: String,
    remove: String,
    clear: String,
    create: String,
    creatable: Boolean
  }

  connect() {
    if (this.element.tomselect) return

    const controller = this
    const plugins = this.element.multiple
      ? { remove_button: { title: this.removeValue } }
      : (this.element.required ? {} : { clear_button: { title: this.clearValue } })

    this.select = new TomSelect(this.element, {
      plugins,
      create: this.creatableValue,
      persist: false,
      placeholder: this.placeholderValue,
      dropdownParent: "body",
      maxOptions: null,
      render: {
        no_results() {
          const message = document.createElement("div")
          message.className = "no-results"
          message.textContent = controller.emptyValue
          return message
        },
        option_create(data) {
          const option = document.createElement("div")
          option.className = "create"
          option.textContent = `${controller.createValue}: ${data.input}`
          return option
        }
      }
    })
  }

  teardown() {
    this.select?.destroy()
    this.select = null
  }

  disconnect() {
    this.teardown()
  }
}
